// NavFooter.js
import { connect } from 'react-redux';

import NavFooter from '../component/NavFooter.jsx';
import withRouter from '../component/WithRouter.jsx';
import getModalData from '../selector/getModalData.js';

const mapStateToProps = (state, { location }) => {
  return {
    pathname: location.pathname,
    hamburgerMenuModalZIndex: getModalData(
      state,
      'HamburgerMenuModal',
      'zIndex'
    ),
  };
};

export default withRouter(connect(mapStateToProps, null)(NavFooter));
